(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[912],{

/***/ 28082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/pagelay/styles.module.scss
var styles_module = __webpack_require__(55124);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(18700);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation.css
var navigation = __webpack_require__(94375);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/pagelay/page_normal/styles.module.scss
var page_normal_styles_module = __webpack_require__(5794);
var page_normal_styles_module_default = /*#__PURE__*/__webpack_require__.n(page_normal_styles_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./stores/index.tsx
var stores = __webpack_require__(62010);
// EXTERNAL MODULE: ./utils/searchNode.ts
var searchNode = __webpack_require__(88257);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/esm/production/react-client/index.js
var react_client = __webpack_require__(81627);
;// CONCATENATED MODULE: ./components/pagelay/page_normal/index.tsx














var PageNormal = function(param) {
    var _banner = param.banner, banner = _banner === void 0 ? "/image/page-banner.png" : _banner, _hasVideo = param.hasVideo, hasVideo = _hasVideo === void 0 ? false : _hasVideo, title = param.title;
    var ref, ref1;
    var nav = (0,react.useContext)(stores/* IndexContext */.Z).nav;
    var ref2 = (0,react.useState)(), menu = ref2[0], setMenu = ref2[1];
    var ref3 = (0,react.useState)(), active = ref3[0], setActive = ref3[1];
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(false), isVideo = ref4[0], setIsVideo = ref4[1];
    var t = (0,react_client/* useTranslations */.T_)();
    var navTo = (0,react.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.out_link) {
            var a = document.createElement("a");
            a.href = "".concat(item.out_link);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    (0,react.useEffect)(function() {
        var act = (0,searchNode/* default */.Z)(nav, router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
    }, [
        nav
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-33094a89f38fb1a5" + " " + ((page_normal_styles_module_default()).page || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-33094a89f38fb1a5" + " " + ((page_normal_styles_module_default()).banner || ""),
                children: hasVideo ? !isVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return setIsVideo(true);
                    },
                    className: "jsx-33094a89f38fb1a5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onError: function(e) {
                                return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                            },
                            src: banner,
                            loading: "lazy",
                            alt: "",
                            className: "jsx-33094a89f38fb1a5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "jsx-33094a89f38fb1a5"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: "/video/home.mp4",
                    controls: true,
                    autoPlay: true,
                    className: "jsx-33094a89f38fb1a5"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    onError: function(e) {
                        return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                    },
                    src: banner,
                    loading: "lazy",
                    alt: "",
                    className: "jsx-33094a89f38fb1a5"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-33094a89f38fb1a5" + " " + ((page_normal_styles_module_default()).pageHeader || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-33094a89f38fb1a5" + " " + ((page_normal_styles_module_default()).infoBox || ""),
                        children: title
                    }),
                    (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "jsx-33094a89f38fb1a5",
                        children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "jsx-33094a89f38fb1a5" + " " + (classnames_default()([
                            (page_normal_styles_module_default()).pageNav
                        ]) || ""),
                        children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                style: {
                                    zIndex: "100",
                                    background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#6354a2" : "",
                                    color: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "white" : "#6354a2"
                                },
                                onClick: function(e) {
                                    return navTo(e, item);
                                },
                                className: "jsx-33094a89f38fb1a5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "jsx-33094a89f38fb1a5",
                                    children: item.name
                                })
                            }, item.id);
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                        className: classnames_default()([
                            (page_normal_styles_module_default()).swiper,
                            "minShow"
                        ]),
                        modules: [],
                        spaceBetween: 0,
                        slidesPerView: "auto",
                        style: {
                            display: "none"
                        },
                        children: [
                            (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "jsx-33094a89f38fb1a5",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-33094a89f38fb1a5",
                                children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                zIndex: "100",
                                                background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#6354a2" : "",
                                                padding: "0 15px",
                                                color: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "white" : "#6354a2"
                                            },
                                            onClick: function(e) {
                                                return navTo(e, item);
                                            },
                                            className: "jsx-33094a89f38fb1a5" + " " + ((page_normal_styles_module_default()).swiperList || ""),
                                            children: item.name
                                        })
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {})
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "33094a89f38fb1a5",
                children: ".mobileSwiper .swiper-slide{width:auto!important}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(10797);
// EXTERNAL MODULE: ./components/pagelay/page_crumb/styles.module.scss
var page_crumb_styles_module = __webpack_require__(34611);
var page_crumb_styles_module_default = /*#__PURE__*/__webpack_require__.n(page_crumb_styles_module);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/index.js + 491 modules
var es = __webpack_require__(89382);
;// CONCATENATED MODULE: ./components/pagelay/page_crumb/index.tsx
















var PageCrumb = function(param) {
    var _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _banner = param.banner, banner = _banner === void 0 ? "/image/page-banner.png" : _banner, partPath = param.partPath;
    var ref, ref1;
    var nav = (0,react.useContext)(stores/* IndexContext */.Z).nav;
    var ref2 = (0,react.useState)(), menu = ref2[0], setMenu = ref2[1];
    var ref3 = (0,react.useState)(), active = ref3[0], setActive = ref3[1];
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(false), isVideo = ref4[0], setIsVideo = ref4[1];
    var t = (0,react_client/* useTranslations */.T_)();
    var navTo = (0,react.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.out_link) {
            var a = document.createElement("a");
            a.href = "".concat(item.out_link);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    (0,react.useEffect)(function() {
        console.log(crumb);
        var act = (0,searchNode/* default */.Z)(nav, partPath || router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
    }, [
        nav
    ]);
    console.log(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).page || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).banner || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        onError: function(e) {
                            return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                        },
                        src: banner,
                        loading: "lazy",
                        alt: "",
                        className: "jsx-1bd2c3c748c44c8c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).title || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-1bd2c3c748c44c8c",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    style: {
                                        transform: router.locale === "cn" ? "translateY(-20px)" : "translateY(-35px)"
                                    },
                                    className: "jsx-1bd2c3c748c44c8c",
                                    children: active === null || active === void 0 ? void 0 : active.name
                                }),
                                (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && !(router.locale === "en" && router.asPath.includes("/event")) && (menu.children.length == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "jsx-1bd2c3c748c44c8c",
                                    children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "jsx-1bd2c3c748c44c8c" + " " + (classnames_default()([
                                        (page_crumb_styles_module_default()).pageNav
                                    ]) || ""),
                                    children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            style: {
                                                zIndex: "100",
                                                background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#6354a2" : ""
                                            },
                                            onClick: function(e) {
                                                return navTo(e, item);
                                            },
                                            className: "jsx-1bd2c3c748c44c8c",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1bd2c3c748c44c8c",
                                                children: item.name
                                            })
                                        }, item.id);
                                    })
                                }))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).pageHeader || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).crumb || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/",
                                className: "jsx-1bd2c3c748c44c8c",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    onError: function(e) {
                                        return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                    },
                                    src: "/image/home.png",
                                    alt: "",
                                    className: "jsx-1bd2c3c748c44c8c"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Breadcrumb */.aG, {
                                compact: false,
                                routes: [
                                    {
                                        path: "/",
                                        name: ""
                                    },
                                    {
                                        path: (active === null || active === void 0 ? void 0 : active.path) || (menu === null || menu === void 0 ? void 0 : menu.path) || "",
                                        name: (menu === null || menu === void 0 ? void 0 : menu.name) || "",
                                        isShow: !menu
                                    },
                                    {
                                        path: (active === null || active === void 0 ? void 0 : active.path) || "",
                                        name: (active === null || active === void 0 ? void 0 : active.name) || "",
                                        isShow: !active
                                    }
                                ].concat((0,_to_consumable_array/* default */.Z)(crumb)).filter(function(item) {
                                    return !item.isShow;
                                }),
                                onClick: function(item) {
                                    router.push(item.path, item.path, {
                                        shallow: true
                                    });
                                },
                                separator: ">"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                        className: classnames_default()([
                            (page_crumb_styles_module_default()).swiper,
                            "minShow",
                            "mobileSwiper"
                        ]),
                        modules: [],
                        spaceBetween: 0,
                        slidesPerView: "auto",
                        style: {
                            display: "none"
                        },
                        children: [
                            (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "jsx-1bd2c3c748c44c8c",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-1bd2c3c748c44c8c",
                                children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                zIndex: "100",
                                                background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#6354a2" : "",
                                                padding: "0 15px",
                                                color: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "white" : "#6354a2"
                                            },
                                            onClick: function(e) {
                                                return navTo(e, item);
                                            },
                                            className: "jsx-1bd2c3c748c44c8c" + " " + ((page_crumb_styles_module_default()).swiperList || ""),
                                            children: item.name
                                        })
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {})
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "1bd2c3c748c44c8c",
                children: ".mobileSwiper .swiper-slide{width:auto!important}.semi-typography{font-size:20px}.semi-breadcrumb-item-title .semi-typography{max-width:none!important;line-height:1.5!important}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pagelay/index.tsx









var PageLayout = function(param) {
    var children = param.children, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "" : _backgroundColor, _banner = param.banner, banner = _banner === void 0 ? "/image/page-banner.png" : _banner, _hasVideo = param.hasVideo, hasVideo = _hasVideo === void 0 ? false : _hasVideo, _title = param.title, title = _title === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    fontSize: "36px"
                },
                children: "IPB 2026 第二十三届国际粉体、散料、流体加工展览会"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    fontSize: "24px",
                    fontWeight: "normal"
                },
                children: "2026年7月22-24日"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    fontSize: "24px",
                    fontWeight: "normal"
                },
                children: "上海世博展览馆"
            })
        ]
    }) : _title, _temp = param.temp, temp = _temp === void 0 ? "page_normal" : _temp, partPath = param.partPath;
    var temps = {
        "page_normal": /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNormal, {
            hasVideo: hasVideo,
            banner: banner,
            title: title
        }),
        "page_crumb": /*#__PURE__*/ (0,jsx_runtime.jsx)(PageCrumb, {
            hasVideo: hasVideo,
            banner: banner,
            crumb: crumb,
            partPath: partPath
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: "jsx-83cb62b2a054563d" + " " + ((styles_module_default()).page || ""),
        children: [
            temps[temp],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-83cb62b2a054563d" + " " + (classnames_default()([
                    (styles_module_default()).content,
                    "content"
                ]) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-83cb62b2a054563d",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        className: "jsx-83cb62b2a054563d",
                        children: children
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "83cb62b2a054563d",
                children: '.semi-navigation{border:none!important;padding:0!important}.semi-navigation-header-text{width:100%}.semi-navigation-header{padding:0!important;margin-top:40px}.semi-navigation-item{height:auto!important;padding:0 12px!important}.semi-navigation-item-text{display:block;width:100%}.semi-navigation-footer{position:absolute;top:0;left:20%}.semi-navigation-list-wrapper{height:auto!important;padding:0!important;margin:10px 0}.semi-breadcrumb-item-active span{color:#6354a2!important}.semi-navigation-collapsed{height:70px!important}.semi-breadcrumb-item-link:hover{color:#808080}.semi-notification-notice{min-width:"200px"}.semi-breadcrumb-item-wrap{margin:4px 6px}'
            })
        ]
    });
};


/***/ }),

/***/ 34611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__1PCVx","banner":"styles_banner__8WosH","title":"styles_title__3MUKj","pageNav":"styles_pageNav__H8OYo","pageHeader":"styles_pageHeader__0P7Aa","swiper":"styles_swiper__afaNm","swiperList":"styles_swiperList__ibxBV","crumb":"styles_crumb__Cgjpd"};

/***/ }),

/***/ 5794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__bjOA0","banner":"styles_banner____Rh4","pageHeader":"styles_pageHeader__HgiKv","infoBox":"styles_infoBox__or2_u","pageNav":"styles_pageNav__cppbK","swiper":"styles_swiper__FuCTX","swiperList":"styles_swiperList__W5b0a"};

/***/ }),

/***/ 55124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__raIZH","content":"styles_content__eWsF4"};

/***/ })

}]);